import React from "react";
import "./CV.css";

export default function CV() {
  return (
    <main className="cv">
      <div className="cv-inner">
        {/* <h1 className="cv-title">Curriculum Vitae</h1> */}

        <div className="cv-actions">
          <a
            href="/CV_Marian_Melnyk_2026.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="cv-button"
          >
            Download CV
          </a>
        </div>

        <div className="cv-viewer">
          <object
            data="/CV_Marian_Melnyk_2026.pdf#view=FitH"
            type="application/pdf"
            className="cv-object"
          >
            <p className="cv-fallback">
              Your browser cannot display the PDF.{" "}
              <a
                href="/CV_Marian_Melnyk_2026.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Open the CV
              </a>
              .
            </p>
          </object>
        </div>
      </div>
    </main>
  );
}
